import { FC, ReactElement } from "react";
import { Button } from "../../buttons";
import styles from './product-short-info.module.scss';

export type ShortInfoActionProps = {
  linkWrapper?: (children: ReactElement) => ReactElement;
  actionTitle: string;
}

export const ShortInfoAction: FC<ShortInfoActionProps> = ({
  linkWrapper,
  actionTitle
}) => {
  const buttonElement = (
    <Button type="button">
      {actionTitle}
    </Button>
  );

  return (
    <div className={styles.action}>
      {linkWrapper ? linkWrapper(buttonElement) : buttonElement}
    </div>
  );
};